import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Stack, StackProps, Typography, useTheme } from "@mui/material";
import { InputField } from "components";
import getStyles from "./styles";

type Props = Omit<StackProps, "onChange"> & {
  text: string;
  onChange: (value: string) => void;
};

const Search: FC<Props> = ({ text, onChange, ...rest }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).Search, [theme]);

  const handleChange = useCallback((_: string, value: number | string) => {
    onChange?.(value as string);
  }, [onChange]);

  return (
    <Stack sx={styles.container} {...rest}>
      <Stack sx={styles.heading}>
        <Typography variant="h1">
          {t("Luminaire Selection")}
        </Typography>
        <Typography variant="h6" fontWeight="normal">{t("You can choose up to three luminiare series")}</Typography>
      </Stack>
      <InputField
        name="searchText"
        value={text}
        placeholder={t("Search...")}
        size="medium"
        onChange={handleChange}
        sx={styles.search}
      />
    </Stack>
  );
};

export default Search;
